import { makeHook } from "../../utils/makeSingleArgHook";
import getRelationshipNoteDetails, { url, } from "../requests/getRelationshipNoteDetails";
export const getRelationshipNoteDetailsKeyMaker = (params) => {
    return [url(params)];
};
const useGetRelationshipNoteDetails = makeHook(getRelationshipNoteDetails, getRelationshipNoteDetailsKeyMaker);
export default useGetRelationshipNoteDetails;
//# sourceMappingURL=useGetRelationshipNoteDetails.js.map